<template>
  <div v-show="loaded">
    <div v-if="status==1" class="st1">
      <img :class="[{'st2_imgs':isphone==1},'st1_img']" src="../../../assets/images/activity/202104sc/sc2.png" />
      <div :class="[{'st2_btns':isphone==1},'st1_btn']">
        <!-- <img @click="getcoupon()" class="st1_btn_img" src="../../../assets/images/activity/202104sc/sc5.png" /> -->
        <div @click="gp()" class="st1_btn_img">{{txt1}}</div>
      </div>
    </div>
    <div v-else class="st2">
      <img :class="[{'st2_imgs':isphone==1},'st2_img']" src="../../../assets/images/activity/202104sc/sc4.png" />
      <div :class=" [{'st2_btns':isphone==1},'st2_btn']">
        <div class="st2_btn_title1">￥<label>{{price}}</label></div>

        <!--
         // coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
         -->
        <div v-show="coupon_type==1||coupon_type==2" class="st2_btn_title2">{{name}}</div>
        <div v-show="coupon_type==3" class="st2_btn_title2">满 ¥{{fullM}} 可用</div>
        <div v-show="coupon_type==4" class="st2_btn_title2">一次抵用券</div>


        <div class="st2_btn_title3">{{rule}}</div>
        <div class="st2_btn_title4">有效期至{{endtime}}</div>

        <img @click="toReseve()" class="st2_btn_img" src="../../../assets/images/activity/202104sc/sc6.png" />
        <div class="st2_btn_txt">券已放入账号：{{phone}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        status:1,
        phone:'',
        coupon:{},
        endtime:'',
        rule:'',
        name:'',
        ac_code:'hBpIimGfN6cSSilO8RDR',
        txt1:'立即领取',
        loaded:false,
        fullM:0,
        isphone:0
      }
    },
    created() { },
    mounted() {
      this.getJsAuth()
      this.getuserinfo()
      this.flGetcouponActivityInfo()
      this.phoneSystem()
    },
    activated() {},
    methods: {
      phoneSystem(){
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(screen.height >800 &&isIOS){
          this.isphone=1

        }else{
          this.isphone=0
        }
        console.log(this.isphone)

      },
      flGetcouponActivityInfo(){
        // this.flGetcouponsByActivity()
        var $this = this
        this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token"),
          ac_code:$this.ac_code
        }
        var qs = require('qs');
        let url = this.api.userApi.flGetcouponActivityInfo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.data) {
            $this.activity_info_status=result.data.activity_info.status
            result.data.coupon_info.amountM=((result.data.coupon_info.amount)/100).toFixed(2)
            if(result.data.coupon_info.amountM%1==0){
              result.data.coupon_info.amountM=parseInt(result.data.coupon_info.amountM,10)
            }


            result.data.coupon_info.fullM=((result.data.coupon_info.full)/100).toFixed(2)
            if(result.data.coupon_info.fullM%1==0){
              result.data.coupon_info.fullM=parseInt(result.data.coupon_info.fullM,10)
            }

            $this.price=result.data.coupon_info.amountM

            $this.fullM=result.data.coupon_info.fullM
            $this.name=result.data.coupon_info.name
            $this.rule=result.data.coupon_info.rule
            // $this.endtime=(result.data.coupon_info.end_date).replace(/-/g,'.')
            // txt1
            if(result.data.activity_info.status==1){
              $this.txt1='立即领取'
              $this.status=1
            }else if(result.data.activity_info.status==4){
              $this.txt1='已抢光'
              $this.status=1
            }else{
              $this.txt1='活动已结束'
              $this.status=1
            }
            if(result.data.user_status==1){
              $this.status=2
              $this.flGetcouponsByActivity()
              // user_status
              // activity_info 的 status 1 正常 2取消 3过期 4已抢光
              // user_status  1 已领取过 2未领取过
            }
            // coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
            $this.coupon_type=result.data.coupon_info.coupon_type
            $this.$loading.close()
            $this.loaded=true

            // $this.status=1
            // activity_info 的 status 1 正常 2取消 3过期 4已抢光
            // user_status  1 已领取过 2未领取过
            // $this.phone=safeTel(result.data.user.mobile)
          } else {
            $this.$loading.close()
            $this.loaded=true
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          $this.loaded=true
        })
      },
      gp(){
        var $this = this
        if(this.txt1=='立即领取'){

          // this.$loading('加载中');
          let param = {
            token: localStorage.getItem("token"),
            ac_code:$this.ac_code
          }
          var qs = require('qs');
          let url = this.api.userApi.flGetreceiveCouponByActivity
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            if (result.code==0) {
              $this.$toast('优惠券领取成功~')
              $this.status=2
              // activity_info 的 status 1 正常 2取消 3过期 4已抢光
              // user_status  1 已领取过 2未领取过
              // $this.phone=safeTel(result.data.user.mobile)
              $this.flGetcouponsByActivity()
            } else {
              $this.$toast(result.msg)
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$loading.close()
          })
        }else{
          console.log(this.txt1)
          $this.$toast(this.txt1)
          setTimeout(function(){
            $this.$router.push({
              name:'reserve'
            })
          },500)
        }
      },
      flGetcouponsByActivity(){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          ac_code:$this.ac_code
        }
        var qs = require('qs');
        let url = this.api.userApi.flGetcouponsByActivity
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==0) {
             $this.endtime=(result.data[0].end_date).replace(/-/g,'.')
            // $this.$toast('优惠券领取成功~')
            // $this.status=2
            // activity_info 的 status 1 正常 2取消 3过期 4已抢光
            // user_status  1 已领取过 2未领取过
            // $this.phone=safeTel(result.data.user.mobile)
          } else {
            // $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
        })
      },
      getJsAuth() {
        // getJsAuth
        let that = this;
        // that.shareApp()
        // return
        var param = {
          url: encodeURIComponent(window.location.href)//location.href.split('#')[0]//encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ],
            openTagList: ['wx-open-launch-weapp']
          });
          wx.ready(function() {
            that.sharefriend()
          });
        }).catch((error) => {
          console.warn(error)
          that.$toast(error);
        })
      },
      sharefriend(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活“专享神券”', // 分享标题
            desc: '斐燃会员五折专享全国五星级酒店游泳、健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('/supercoupon')[0])+'/supercoupon', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateAppMessageShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活“专享神券”', // 分享标题
            link: encodeURI((window.location.href).split('/supercoupon')[0])+'/supercoupon', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateTimelineShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活“专享神券”', // 分享标题
            desc: '斐燃会员五折专享全国五星级酒店游泳、健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('/supercoupon')[0])+'/supercoupon', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareAppMessage')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活“专享神券”', // 分享标题
            link: encodeURI((window.location.href).split('/supercoupon')[0])+'/supercoupon', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareTimeline')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareTimeline')
            }
          });
        }
      },
      getcoupon(){
        // flreceiveCouponByTempActivity

        var $this = this
        // this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flreceiveCouponByTempActivity
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==0) {
            $this.$toast('优惠券领取成功~')
            $this.status=2
            $this.endtime=(result.data.end_date).replace(/-/g,'.')
            $this.coupon=result.data.info
            $this.rule=result.data.info.rule
            $this.name=result.data.info.name
            var price=(parseFloat(result.data.info.amount,10)/100).toFixed(2)
            if(price%1==0){
              price=parseInt(price,10)
            }
            $this.price=price
            // $this.phone=safeTel(result.data.user.mobile)
          } else {
            $this.$toast(result.msg)
            setTimeout(function(){
              $this.$router.push({
                name:'reserve'
              })
            },500)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$toast(result.msg)
          // $this.$loading.close()
        })
      },
      toReseve(){
        this.$router.push({
          name:'reserve'
        })
      },
      getuserinfo(){
        var $this = this
        // this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.data) {
            $this.phone=safeTel(result.data.user.mobile)
          } else {

          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
        })
      }
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .st1{
    position: relative;
    width: 100%;
    height: 100vh;
    background: url(../../../assets/images/activity/202104sc/sc1.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    .st1_img{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      margin-bottom: 20*@vm_base;
    }
    .st1_btn{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 2;
      padding: 0 112*@vm_base 105*@vm_base 112*@vm_base;
      .st1_btn_img{
        width: 100%;
        text-align: center;
        background: linear-gradient(270deg, #D57412 0%, #EEAA48 36%, #E58218 74%, #C8680E 100%) linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%);
        box-shadow: -0*@vm_base -10*@vm_base 30*@vm_base 0*@vm_base rgba(150, 86, 24, 0.6), -1*@vm_base -2*@vm_base 3*@vm_base 0*@vm_base #FFF0B7, 0*@vm_base 4*@vm_base 9*@vm_base 0*@vm_base rgba(255, 246, 222, 0.5);
        border-radius: 45*@vm_base;
        padding: 23*@vm_base;

        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        letter-spacing: 3*@vm_base;


      }
    }
    .st2_btns{
      padding: 0 112*@vm_base 205*@vm_base 112*@vm_base;
    }
    .st2_imgs{
      margin-bottom: 120*@vm_base;
    }
  }
  .st2{
    position: relative;
    width: 100%;
    height: 100vh;
    background: url(../../../assets/images/activity/202104sc/sc3.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    .st2_img{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      margin-bottom: 20*@vm_base;
    }
    .st2_btn{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      padding: 0 83*@vm_base 129*@vm_base 83*@vm_base;
      .st2_btn_title1{
        width: 100%;
        font-size: 28*@vm_base;
        font-weight: 600;
        color: #A75531;
        line-height: 1;
        text-align: center;
        label{
          font-size: 100*@vm_base;
          font-weight: 600;
          color: #A75531;
        }
      }
      .st2_btn_title2{
        width: 100%;
        font-size: 28*@vm_base;
        font-weight: 500;
        color: #B26A4A;
        line-height: 1;
        letter-spacing: 2*@vm_base;
        text-align: center;
        margin: 24*@vm_base 0 54*@vm_base 0;
      }
      .st2_btn_title3{
        width: 100%;
        font-size: 22*@vm_base;
        font-weight: 400;
        color: #B26A4A;
        line-height: 1;
        text-align: center;
        letter-spacing: 1*@vm_base;
        margin-bottom: 20*@vm_base;
      }
      .st2_btn_title4{
        width: 100%;
        font-size: 22*@vm_base;
        font-weight: 400;
        color: #B26A4A;
        line-height: 1;
        text-align: center;
        letter-spacing: 1*@vm_base;
        margin-bottom: 113*@vm_base;
      }
      .st2_btn_img{
        width: 100%;
      }
      .st2_btn_txt{
        width: 100%;
        text-align: center;
        font-size: 26*@vm_base;
        font-weight: 400;
        color: #F2E0CC;
      }
    }
    .st2_btns{
      padding: 0 83*@vm_base 229*@vm_base 83*@vm_base;
    }
    .st2_imgs{
      margin-bottom: 120*@vm_base;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/activity/supercoupon/supercoupon.vue